import React, { Component } from 'react';
import config from '../config';
import $ from 'jquery'
import ContentLeft from './content/content-left/content-left';
import ContentRight from './content/content-right/content-right';
import Header from './header/header';
import MetaTags from 'react-meta-tags';
import API_Config from '../API_Config';
import SEO from '../SEO/seo';

class ReportDescription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rpt_des: {
                description:{
                    full_description:''
                },
                content:{
                    table:''
                }
            },
            slug   : props.match.params.slug,
            error: null,
            isLoaded:true
        };
        config.isLoaded = false;

        this.GetContentData(this.state.slug);
        localStorage.setItem('catData',"");

        if(props.match.params.sub != "") {

        }


    }

    GetContentData(param) {

        let url = API_Config.http_url + API_Config.end_point.rpt_desc + param;

        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {

                    config.data = result;
                    config.price =JSON.parse(JSON.stringify(result));
                    config.isLoaded= true
                    console.log(config)
                    this.setState({
                        isLoaded: true,
                        rpt_des: result
                    });
                    localStorage.setItem('reportdata',JSON.stringify(result));
                    localStorage.setItem("strSrch","");

                },
                (error) => {
                    localStorage.setItem("strSrch","");
                }
            )

    }

    render() {
        let data = config;

            return (

                <section class="mi-re1">
                    {/*<MetaTags defer={false}>*/}
                        {/*<title> {config.data.meta.tags}</title>*/}
                        {/*<meta id="description" name="description" content={config.data.meta.description} />*/}
                        {/*<meta id="title" property="og:title" content={config.data.title} />*/}
                        {/*<meta id="image" property="og:image" content={config.data.picture_url} />*/}
                        {/*<meta id="keywords" name="keywords" content={config.data.meta.keywords} />*/}
                    {/*</MetaTags>*/}
                    <SEO
                        schema="Report Description Page"
                        title={config.data.meta.tags}
                        description={config.data.meta.description}
                        keywords={config.data.meta.keywords}
                        path="/"
                        contentType="Report Page"
                    />
                    <div class="container ">
                        <Header />
                        <div className="relo">

                            <ContentLeft  data={data} />

                            <ContentRight data_data={data} />

                        </div>
                    </div>
                </section>
            );


    }


}


export default ReportDescription;


// WEBPACK FOOTER //
// ./src/report-description/report-description.js